import type { Scores } from "../api/gameData";

interface ScoreBoardProps {
  scores: Scores;
}

export function ScoreBoard({ scores }: ScoreBoardProps) {
  return (
    <div
      className="flex items-center justify-center gap-3 sm:gap-6"
      style={{ animation: "fadeIn 0.3s ease-out" }}
    >
      <ScoreItem label="X" value={scores.X} color="var(--color-x)" />
      <Divider />
      <ScoreItem label="Draw" value={scores.draws} color="var(--color-draw)" />
      <Divider />
      <ScoreItem label="O" value={scores.O} color="var(--color-o)" />
    </div>
  );
}

function ScoreItem({ label, value, color }: { label: string; value: number; color: string }) {
  return (
    <div className="flex flex-col items-center gap-1 min-w-[60px] sm:min-w-[72px]">
      <span
        className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold"
        style={{ color, fontFamily: "var(--font-display)" }}
      >
        {label}
      </span>
      <span
        className="text-2xl sm:text-3xl font-bold tabular-nums"
        style={{ color, fontFamily: "var(--font-mono)" }}
      >
        {value}
      </span>
    </div>
  );
}

function Divider() {
  return (
    <div
      className="w-px h-10 sm:h-12"
      style={{ backgroundColor: "var(--game-border)" }}
    />
  );
}
